import React, { useState } from 'react';
import ClinicLayout from './ClinicLayout';
import { Edit, Trash2, Printer, Send } from 'lucide-react';

const ClinicClaimsBilling = () => {
  const [claims] = useState([
    { claimNo: 'CLM-001', dateCreated: '01/26/2026', formType: 'CMS-1500', fromDOS: '01/26/2026', toDOS: '01/26/2026', patientName: 'Smith, John', totalCharges: 250.00, insuranceCo: 'Blue Cross Blue Shield', insType: 'Primary', secClaim: 'N', status: 'Submitted' },
    { claimNo: 'CLM-002', dateCreated: '01/26/2026', formType: 'CMS-1500', fromDOS: '01/26/2026', toDOS: '01/26/2026', patientName: 'Johnson, Mary', totalCharges: 175.00, insuranceCo: 'Aetna', insType: 'Primary', secClaim: 'N', status: 'Ready' },
    { claimNo: 'CLM-003', dateCreated: '01/25/2026', formType: 'CMS-1500', fromDOS: '01/25/2026', toDOS: '01/25/2026', patientName: 'Davis, Robert', totalCharges: 425.00, insuranceCo: 'United Healthcare', insType: 'Primary', secClaim: 'Y', status: 'Paid' },
  ]);

  return (
    <ClinicLayout activeTab="claims-billing">
      <div className="p-4 pr-20" data-testid="clinic-claims-billing">
        {/* Sub Navigation Tabs */}
        <div className="flex items-center border-b border-gray-300 mb-4">
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Add New Claim</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-white -mb-px">Claim List</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Claims Awaiting Batch</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Repairable Claims</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Reports</button>
        </div>

        {/* Section Header */}
        <div className="bg-gradient-to-b from-[#4a5568] to-[#2d3748] text-white px-3 py-2 text-sm font-medium mb-4">
          Claim List
        </div>

        {/* Filters */}
        <div className="bg-[#f5f5f5] border border-gray-300 p-3 mb-4">
          <div className="space-y-2 text-xs">
            {/* Row 1 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-20">Date Created:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>By Date</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-20" placeholder="01/26/2026" />
              </div>
            </div>
            
            {/* Row 2 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-20">Search For:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Claim Number</option>
                </select>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Starts With</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-32" />
                <button className="border border-gray-400 px-3 py-0.5 bg-gray-100">Search</button>
              </div>
            </div>

            {/* Row 3 - Display Filters */}
            <div className="flex items-center gap-4 flex-wrap">
              <span className="font-medium">Display Filter:</span>
              <div className="flex items-center gap-2">
                <label>Form Type:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Status:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Facility:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
            </div>

            {/* Row 4 - Print Options */}
            <div className="flex items-center gap-4">
              <span className="font-medium">Print Options:</span>
              <label className="flex items-center gap-1">
                <input type="radio" name="printOpt" defaultChecked /> CMS-1500
              </label>
              <label className="flex items-center gap-1">
                <input type="radio" name="printOpt" /> UB-04
              </label>
              <span className="ml-4 font-medium">CMS Form Version:</span>
              <label className="flex items-center gap-1">
                <input type="radio" name="cmsVer" defaultChecked /> 02/12
              </label>
              <label className="flex items-center gap-1">
                <input type="radio" name="cmsVer" /> 08/05
              </label>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-gray-300">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-[#1e3a5f] text-white">
                <th className="p-1 border border-gray-400 text-left">Claim No</th>
                <th className="p-1 border border-gray-400 text-left">Date Created</th>
                <th className="p-1 border border-gray-400 text-left">Form Type</th>
                <th className="p-1 border border-gray-400 text-left">From DOS</th>
                <th className="p-1 border border-gray-400 text-left">To DOS</th>
                <th className="p-1 border border-gray-400 text-left">Patient Name</th>
                <th className="p-1 border border-gray-400 text-right">Total Charges</th>
                <th className="p-1 border border-gray-400 text-left">Insurance Co.</th>
                <th className="p-1 border border-gray-400 text-left">Ins. Type</th>
                <th className="p-1 border border-gray-400 text-center">Sec. Claim</th>
                <th className="p-1 border border-gray-400 text-left">Status</th>
                <th className="p-1 border border-gray-400 text-center">Edit</th>
                <th className="p-1 border border-gray-400 text-center">Del</th>
                <th className="p-1 border border-gray-400 text-center">Print</th>
                <th className="p-1 border border-gray-400 text-center">Submit</th>
              </tr>
            </thead>
            <tbody>
              {claims.map((claim, index) => (
                <tr key={claim.claimNo} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{claim.claimNo}</td>
                  <td className="p-1 border border-gray-300">{claim.dateCreated}</td>
                  <td className="p-1 border border-gray-300">{claim.formType}</td>
                  <td className="p-1 border border-gray-300">{claim.fromDOS}</td>
                  <td className="p-1 border border-gray-300">{claim.toDOS}</td>
                  <td className="p-1 border border-gray-300 font-medium">{claim.patientName}</td>
                  <td className="p-1 border border-gray-300 text-right">${claim.totalCharges.toFixed(2)}</td>
                  <td className="p-1 border border-gray-300">{claim.insuranceCo}</td>
                  <td className="p-1 border border-gray-300">{claim.insType}</td>
                  <td className="p-1 border border-gray-300 text-center">{claim.secClaim}</td>
                  <td className="p-1 border border-gray-300">{claim.status}</td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Edit className="w-3 h-3 inline cursor-pointer text-blue-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Trash2 className="w-3 h-3 inline cursor-pointer text-red-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Printer className="w-3 h-3 inline cursor-pointer text-gray-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Send className="w-3 h-3 inline cursor-pointer text-green-600" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-3 flex items-center gap-2 text-xs">
          <span>|◀ ◀◀</span>
          <span>Page</span>
          <input type="text" className="border border-gray-400 w-8 text-center" defaultValue="1" />
          <span>of 1</span>
          <span>▶▶ ▶|</span>
          <select className="border border-gray-400 px-1">
            <option>10</option>
          </select>
          <span className="ml-4 text-gray-500">Showing 1 to {claims.length} of {claims.length} entries</span>
        </div>
      </div>
    </ClinicLayout>
  );
};

export default ClinicClaimsBilling;
